var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPersonAdd24Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9993 12.0011C18.2093 12.0013 19.9995 10.2115 19.9997 8.00148C19.9999 5.79148 18.21 4.00133 16 4.00115C13.79 4.00097 11.9999 5.79082 11.9997 8.00082C11.9995 10.2108 13.7893 12.001 15.9993 12.0011ZM15.9998 6.00115C17.0998 6.00124 17.9998 6.90131 17.9997 8.00131C17.9996 9.10131 17.0995 10.0012 15.9995 10.0011C14.8995 10.0011 13.9996 9.10098 13.9997 8.00098C13.9998 6.90098 14.8998 6.00106 15.9998 6.00115ZM7.99885 18.0005C7.99907 15.3405 13.3292 14.0009 15.9992 14.0011C18.6692 14.0014 23.9991 15.3418 23.9989 18.0018L23.9987 20.0018L7.99869 20.0005L7.99885 18.0005ZM9.99885 18.0007C10.2189 17.2807 13.309 16.0009 15.999 16.0011C18.699 16.0014 21.7989 17.2916 21.9989 18.0016L9.99885 18.0007ZM6.99934 12.0004L6.9991 15.0004L4.9991 15.0002L4.99934 12.0002L1.99934 12L1.99951 10L4.99951 10.0002L4.99975 7.00025L6.99975 7.00041L6.99951 10.0004L9.99951 10.0007L9.99934 12.0007L6.99934 12.0004Z",
    fill: "#505255"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonAdd24Px);
export default __webpack_public_path__ + "static/media/person_add_24px.ef5b6bc596b08f8d55896b9fc357547c.svg";
export { ForwardRef as ReactComponent };